import { render } from "./ListLink.vue?vue&type=template&id=40e036ea"
import script from "./ListLink.vue?vue&type=script&lang=js"
export * from "./ListLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__